/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from "react";

const MyClassesContext = createContext({
  setWidthToClassCard: (width: number) => {},
});

export default MyClassesContext;
